<template>
    <div class="setting-perfer">
        <div class="perfer-head">
            <span>{{index+1}}级阶梯优惠</span>
            <img v-show="length>1" src="../../../assets/image/trash@2x.png" @click="onPreferDelete" />
        </div>
        <div class="perfer-content">
            <InputItem class="perfer-input" :keyValue="perfer.conditionValue" keyName="conditionValue" :unit="typeObj.val1" :label="typeObj.key1" placeholder="请输入" @change="inputChange" :type="type == 4 ||type == 1 ? 'digit': 'number'" ></InputItem>
            <InputItem class="perfer-input" :keyValue="perfer.discountValue" keyName="discountValue" :unit="typeObj.val2" :label="typeObj.key2" placeholder="请输入" @change="inputChange" ></InputItem>
        </div>
    </div>
</template>

<script>
import InputItem from './inputItem';
export default {
    props: {
        index: {
            default: 0,
            type: Number
        },
        item: {
            default: function() {
                return {}
            },
            type: Object
        },
        typeObj: {
            default: function() {
                return {}
            },
            type: Object
        },
        length: {
            default: 0,
            type: Number
        }
    },
    data() {
        return {
            type: this.$route.query.type || 1, 
            perfer: {
                conditionValue: '',
                discountValue: '',
                sort: ''
            }
        }
    },
    created() {
        Object.assign(this.perfer, this.item)
    },
    watch: {
        item: function(val) {
            Object.assign(this.perfer, this.item)
        }
    },
    methods: {
        inputChange(obj) {
            this.perfer[obj.key] = obj.value
            this.$emit('inputChange', { perfer: {...this.perfer, sort: this.item.sort}, index: this.index})
        },
        onPreferDelete() {
            this.$emit('delete', this.index)
        }
    },
    components: {
        InputItem
    }
}
</script>

<style lang="less" scoped>
.setting-perfer {
    background-color: #fff;
    .perfer-head {
        height: 82px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px;
        background-color: #F7F7F7;

        span {
            font-size: 28px;
            line-height: 40px;
            font-weight: 500;
        }

        img {
            width: 44px;
            height: 44px;
        }
    }

    .perfer-content {
        padding: 30px 40px;

        .perfer-input:not(:last-child) {
            margin-bottom: 20px;
        }
    }

}
</style>